import Vue from 'vue';
import { getMyAwards } from '../../api';
import { AWARD_TYPE_ID_MAP } from '../../constants';

// 我的奖品页奖项数据处理
function resolveMyAwards(awards) {
  const parsedAwards = awards.map(originAward => {
    const typeStr = AWARD_TYPE_ID_MAP[originAward.rewardType];
    let ext = {};
    if (typeStr === 'COUPON') {
      ext = {
        detail: {
          discountAmount: originAward.discountAmount,
          discountRate: originAward.discountRate,
          discountType: originAward.discountType,
          businessType: originAward.businessType,
          thresholdAmount: originAward.reachFen
        }
      };
    }
    return {
      ...originAward,
      ...ext,
      rewardTypeId: originAward.rewardType,
      rewardType: typeStr
    };
  });
  return parsedAwards;
}

// 我的奖品页
export default {
  namespaced: true,
  state() {
    return {
      tabBarConfig: [],
      awardsList: null,
      actCode: null
    };
  },
  actions: {
    async getAwardsList({ commit, state }) {
      Vue.prototype.$hll.showLoading({});
      let result = [];
      try {
        result = await getMyAwards({
          rewardType: 4,
          code: state.actCode
        });
      } catch (error) {
        Vue.prototype.$hll.toast(error && error.msg);
        throw error;
      } finally {
        Vue.prototype.$hll.hideLoading();
      }
      const resolvedAwards = resolveMyAwards(result);
      commit('updateAwardsData', resolvedAwards);
    }
  },
  getters: {
    checkIsHasUserAddress(state) {
      return Boolean(state.userAddress);
    }
  },
  mutations: {
    switchTab(state, tabId) {
      state.currentActiveTabId = tabId;
    },
    setTabConfig(state, config) {
      state.tabBarConfig = config;
    },
    updateCashPackData(state, data) {
      state.cashPackData = data;
    },
    updateAwardsData(state, data) {
      state.awardsList = data;
    },
    setActCode(state, val) {
      state.actCode = val;
    }
  }
};
